<section class="seller-container" *ngIf="!isLoadingData && !showError">
  <div class="ids-mv-6 ids-p-3">
    <div class="breadcrumb-box">
      <button idsActionButton (click)="backStep()">
        <ids-icon variant="primary" #backButton id="backButton">seta_esquerda</ids-icon>
        voltar
      </button>
    </div>

    <div class="ids-mb-8 ids-mt-6">
      <h1 class="ids-mb-4">Divisão do imóvel</h1>
      <p>Escolha qual percentual do imóvel cada conta vai receber. A divisão é feita entre todos os vendedores e o total
        deve somar 100%</p>
    </div>

    <app-progress-bar></app-progress-bar>
    <app-seller-percent [cnpjSeller]="cnpjSeller" [sellersPercentage]="sellerPercentageData"
                        (buttonStateChange)="updateButtonState()"></app-seller-percent>
    <app-other-sellers-percent [otherSellers]="sellerPercentageData?.otherSellers"
                               *ngIf="sellerPercentageData?.otherSellers?.length > 0"></app-other-sellers-percent>

    <section class="ids-row ids-mt-10">
      <section class="ids-col-4 ids-pt-7">
        <button idsMainButton full
                [disabled]="isButtonDisabled"
                [loading]="btnLoading"
                (click)="savePercentageSeller()">
          salvar formulário
        </button>
      </section>
    </section>
  </div>
</section>

<section *ngIf="isLoadingData" class="container-idl ids-d-flex ids-flex-column" aria-live="polite">
  <ids-shimmer [show]="isLoadingData" height="10vh" class="ids-m-2"></ids-shimmer>
  <ids-shimmer [show]="isLoadingData" height="10vh" class="ids-m-2"></ids-shimmer>
  <ids-shimmer [show]="isLoadingData" height="60vh" class="ids-m-2"></ids-shimmer>
  <ids-shimmer [show]="isLoadingData" height="10vh" class="ids-m-2"></ids-shimmer>
</section>

<section *ngIf="showError" class="seller-container">
  <section class="ids-mv-6 ids-p-3">
    <app-error-screen *ngIf="showError" (onClickTryAgain)="reciverTryAgain()"
                      [errorCount]="errorCount"></app-error-screen>
  </section>
</section>
